import React from 'react';
import ReactTooltip from 'react-tooltip';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import Layout from '../layout';
import {
  isMobileDevice, getInsightsDomain, getContentDomain, getFeeDomain,
} from '../../helpers/util';
import { showUserDetails, getUserTypes } from '../../actions';
import Constants from '../../shared/constants';
import ReferalModal from '../modal/referalModal';
import TermsForReferalModal from '../modal/termsForReferalModal';
import './home.css';
import '../modal/referalModal.css';
import Loader from '../loading';
import questionsBoard from '../../static/images/questionsBoard.svg';
import insightsBoard from '../../static/images/insightsBoard.svg';
import filesBoard from '../../static/images/filesBoard.svg';
import virtualMeeting from '../../static/images/virtualMeeting.svg';
import quizBoard from '../../static/images/quizBoard.svg';
import contentBoard from '../../static/images/contentBoard.svg';
import feeBoard from '../../static/images/rupee-symbol.svg';
import interactionBoard from '../../static/images/interactionBoard.svg';
import surveysBoard from '../../static/images/surveysBoard.svg';
import admissionBoard from '../../static/images/admission_board.svg'
import hrBoard from "../../static/images/hr-board.svg"

const IS_MOBILE = isMobileDevice();

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: true,
    };
  }

  componentDidMount() {
    this.props.getUserTypes().then(() => {
      this.props.showUserDetails().then(() => {
        this.setState(() => ({ showLoader: false }));
      });
    });
  }

  renderSpecificDomain(img, text, info, backgroundColor, fontColor, access) {
    return (
      <div
        role="presentation"
        style={{
          display: 'flex',
          flexDirection: 'column',
          cursor: 'pointer',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          backgroundColor: '#fff',
          borderRadius: 16,
          padding: IS_MOBILE ? '24px 20px' : '36px 32px',
          width: '100%',
          height: '100%',
          boxSizing: 'border-box',
          minHeight: IS_MOBILE ? 140 : 180,
          boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
          border: '1px solid #F0F0F5',
          transition: 'all 0.25s ease',
          userSelect: 'none',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = '0 8px 30px rgba(108,92,231,0.12)';
          e.currentTarget.style.transform = 'translateY(-3px)';
          e.currentTarget.style.borderColor = '#6C5CE730';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)';
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.borderColor = '#F0F0F5';
        }}
      >
        <div style={{
          width: IS_MOBILE ? 48 : 56,
          height: IS_MOBILE ? 48 : 56,
          borderRadius: 14,
          backgroundColor: backgroundColor || '#F5F5F5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 20,
        }}>
          <img alt="" src={img} style={{ height: IS_MOBILE ? 26 : 30 }} />
        </div>
        <div style={{
          fontSize: IS_MOBILE ? 16 : 20,
          fontWeight: 700,
          color: '#1a1a2e',
          marginBottom: 8,
        }}>
          {text}
        </div>
        <div style={{
          fontSize: IS_MOBILE ? 12 : 14,
          color: '#8B8FA3',
          lineHeight: 1.6,
        }}>
          {info}
        </div>
      </div>
    );
  }

  renderDomain(img, text, type, info, backcolor, fontColor, linkDisabled, access, toolTipMessage) {
    if (linkDisabled) {
      return (
        <div data-place="right" data-tip={toolTipMessage} style={{ opacity: 0.4 }}>
          <ReactTooltip effect="solid" />
          {this.renderSpecificDomain(img, text, info, backcolor, fontColor, access)}
        </div>
      );
    }
    return (
      <a
        style={{ textDecoration: 'none' }}
        href={type}
      >
        {this.renderSpecificDomain(img, text, info, backcolor, fontColor, access)}
      </a>
    );
  }

  render() {
    const { showLoader } = this.state;
    if (showLoader) {
      return <Loader type="welcome" />;
    }
    const { newUser, hasContentBoardAccess, hasFeeBoardAccess, isDtpAdmin, isAccountant,isAdmin, hasAdmissionBoardAccess } = this.props;
    const user = new Cookies().get('user');
    const referralBannerWidth = 1000;
    const isHigherEducation = user && user.is_higher_education;
    const pagesData = [
      {
        url: "/list/test",
        name: "questionsBoard",
        img: questionsBoard,
        text: "Questions Board",
        info: "Create tests and assignments in 10 min.",
        backColor: "#D0ECE6",
        fontColor: "#4B7B7A",
        isDisabled: false,
        show: !isHigherEducation,
        access: newUser,
      },
      {
        url: getInsightsDomain(),
        name: "insightsBoard",
        img: insightsBoard,
        text: "Insights Board",
        info: "Get to know your students better than ever before.",
        backColor: "#EFEFE7",
        fontColor: "#817A75",
        isDisabled: false,
        show: !isHigherEducation,
        access: false,
      },
      {
        url: `${getFeeDomain()}${
          !isAdmin && isAccountant ? "/student_list" : "/dashboard"
        }`,
        name: "feeBoard",
        img: feeBoard,
        text: "Fee Board",
        info: "Automate your institute’s fee management",
        backColor: "#2ff5e1",
        fontColor: "#198a7e",
        isDisabled: !hasFeeBoardAccess,
        show: !isHigherEducation,
        access: false,
        toolTipMessage: `Contact customer support - ${Constants().contact}`,
      },
      {
        url: "/files_board",
        name: "filesBoard",
        img: filesBoard,
        text: "Files Board",
        info: "Share files with your students.",
        backColor: "#E3F7FF",
        fontColor: "#0476BE",
        isDisabled: IS_MOBILE,
        show: false,
        access: false,
      },
      {
        url: isDtpAdmin
          ? "/classboard/dashboard"
          : "/classboard/virtual_meeting",
        name: "virtualMeeting",
        img: virtualMeeting,
        text: "Class Board",
        info: "Conduct Live Classes for your Students",
        backColor: "#ffe3fd",
        fontColor: "#bf65b9",
        isDisabled: false,
        show: false,
        access: false,
      },
      {
        url: "/quizboard",
        name: "quizBoard",
        img: quizBoard,
        text: "Quiz Board",
        info: "Interact with your students, parents and teachers.",
        backColor: "#FFE3E3",
        fontColor: "#BE0404A3",
        isDisabled: false,
        show: false,
        access: false,
      },
      {
        url: getContentDomain(),
        name: "contentBoard",
        img: contentBoard,
        text: "Content Board",
        info: "Import your own content",
        backColor: "#22222224",
        fontColor: "#6C757D",
        isDisabled: !hasContentBoardAccess,
        show: !isHigherEducation,
        access: false,
        toolTipMessage: `Contact customer support - ${Constants().contact}`,
      },
      {
        url: "/admission_board/applicants",
        img: admissionBoard,
        name: "admissionBoard",
        text: "Admission Board",
        info: "Manage your admissions.",
        backColor: "#F5DEB3",
        fontColor: "#8B4513",
        isDisabled: !hasAdmissionBoardAccess,
        show: false,
        access: false,
        toolTipMessage: `Contact customer support - ${Constants().contact}`,
      },
    ];
    if (IS_MOBILE === '') {
      return <Layout />;
    }
    return (
      <Layout globalHistory={this.props.history} isMobile={IS_MOBILE}>
        <div style={{
          backgroundColor: '#F7F8FC', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '80vh',
        }}
        >
          <div style={{ paddingTop: IS_MOBILE ? 20 : 48 }} />
          <div style={{ textAlign: 'center', marginBottom: IS_MOBILE ? 20 : 32 }}>
            <div style={{ fontSize: IS_MOBILE ? 22 : 28, fontWeight: 700, color: '#1a1a2e' }}>Welcome back</div>
            <div style={{ fontSize: IS_MOBILE ? 13 : 15, color: '#8B8FA3', marginTop: 6 }}>Choose a board to get started</div>
          </div>
          <div
            className="nunito-body"
            style={{
              display: 'grid',
              gridTemplateColumns: IS_MOBILE ? '1fr' : '1fr 1fr',
              gap: IS_MOBILE ? 12 : 24,
              width: IS_MOBILE ? '100%' : 680,
              marginBottom: 40,
              padding: IS_MOBILE ? '0 16px' : 0,
            }}
          >
            {pagesData.filter((p) => p.show).map((pageData) => {
              return this.renderDomain(pageData.img, pageData.text, pageData.url, pageData.info, pageData.backColor, pageData.fontColor, pageData.isDisabled, pageData.access, pageData.toolTipMessage || 'Coming Soon!');
            })}
          </div>
          {/* {!IS_MOBILE
            && (
            <div style={{
              display: 'flex', justifyContent: 'center', maxWidth: '50%', margin: 'auto', marginBottom: 20,
            }}
            >
              <div
                className="refer-now-container"
                style={{
                  display: 'flex', justifyContent: 'space-between', position: isHigherEducation ? 'absolute' : 'relative', padding: 25, cursor: 'default', width: referralBannerWidth, bottom: 20,
                }}
              >
                <div className="refer-now-container-text">
                  <div>For Every Institute you refer,</div>
                  <div>Earn upto ₹ 10,000/- *</div>
                </div>
                <div style={{
                  display: 'flex', flexDirection: 'column', justifyContent: 'space-between', marginRight: 50,
                }}
                >
                  <ReferalModal />
                  <div style={{ textAlign: 'center', color: '#FFFFFF', fontSize: 16 }}>
                    Call &nbsp;
                    {Constants().contact}
                  </div>
                </div>
                <div style={{ left: 28, bottom: 5, position: 'absolute' }}>
                  <TermsForReferalModal />
                </div>
              </div>
            </div>
            )} */}
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = ({ institute, auth }) => ({
  newUser: institute.newUser,
  hasContentBoardAccess: institute.hasContentBoardAccess,
  hasFeeBoardAccess: institute.hasFeeBoardAccess,
  isDtpAdmin: institute.isDtpAdmin,
  isAccountant: institute.isAccountant,
  isAdmin: auth.isAdmin,
  hasAdmissionBoardAccess: institute.hasAdmissionBoardAccess
});

export default connect(mapStateToProps, { showUserDetails, getUserTypes })(Home);
